module.exports = __webpack_public_path__ + "img/touxiang.dc893e17.png";